/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import {assert} from 'Asserts';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import HelpIcon from 'ui-library/icons/HelpIcon';

import EnzymeConstants from './EnzymeConstants';
import {Provider} from './EnzymeConstants';
import * as EnzymeUtil from './EnzymeUtil';

interface Props {
  value: Provider;
  onChange?: (...args: Array<any>) => any;
  providers: Array<Provider>;
  inline: boolean;
  small: boolean;
}

class EnzymeProviderSelector extends React.Component<Props> {
  static defaultProps = {
    inline: false,
    small: false,
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  providerSelectHandler = (e: any) => {
    assert(this.props.onChange != null, 'must provide onChange');
    let provider = EnzymeUtil.getBaseProvider(e.target.value);

    // Use the subProvider if the provider is not available.
    if (!Array.from(this.props.providers).includes(provider)) {
      assert(
        provider.subProvider != null && Array.from(this.props.providers).includes(provider.subProvider),
        `${provider.name} does not have a subProvider in [${this.props.providers.map((p) => p.name)}]`
      );
      provider = provider.subProvider;
    }

    this.props.onChange(provider);
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  subproviderToggleHandler = (e: any) => {
    assert(this.props.onChange != null, 'must provide onChange');

    const baseProvider = EnzymeUtil.getBaseProvider(this.props.value.name);
    const provider = e.target.checked ? baseProvider.subProvider : baseProvider;
    assert(provider != null, 'expected provider to exist');

    this.props.onChange(provider);
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  renderSubProviderChooser = () => {
    let message;
    const selectedProvider = this.props.value;
    const selectedBaseProvider = EnzymeUtil.getBaseProvider(selectedProvider.name);
    const isReadOnly = this.props.onChange == null;

    const selectedSubProvider = selectedBaseProvider.subProvider;
    if (selectedSubProvider == null) {
      return null;
    }

    // The checkbox for subprovider is only enabled if both the base provider and the subprovider are
    // possible choices in the given list of providers.
    let subProviderChoiceEnabled = false;
    if (!Array.from(this.props.providers).includes(selectedSubProvider)) {
      message = `No ${selectedSubProvider.shortName} version of the enzyme exists`;
    } else if (!Array.from(this.props.providers).includes(selectedBaseProvider)) {
      message = `Only ${selectedSubProvider.shortName} version of the enzyme exists`;
    } else if (isReadOnly) {
      message = 'read-only';
    } else {
      subProviderChoiceEnabled = true;
    }

    const subProviderCheckbox = (
      <label
        className={classNames({
          'u-tiny-spacing-top': !this.props.inline,
          'u-small-spacing-left': this.props.inline && !this.props.small,
          'u-tiny-spacing-left': this.props.inline && this.props.small,
          'u-no-spacing-bottom': !this.props.small,
          'u-tiny-spacing-bottom': this.props.small,
        })}
      >
        <input
          type="checkbox"
          className="u-valign-text-bottom"
          checked={selectedSubProvider === selectedProvider}
          disabled={!subProviderChoiceEnabled}
          onChange={this.subproviderToggleHandler}
        />
        <span className={classNames('u-valign-middle', {faded: !subProviderChoiceEnabled})}>
          {`Use ${selectedSubProvider.shortName} `}
        </span>
        <a
          className="faded u-valign-middle"
          href={selectedSubProvider.infoLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <HelpIcon />
        </a>
      </label>
    );

    if (subProviderChoiceEnabled) {
      return subProviderCheckbox;
    }

    return (
      <Tooltip title={message} placement={TooltipPlacement.BOTTOM} container="body" delay={{show: 500}}>
        {subProviderCheckbox}
      </Tooltip>
    );
  };

  render(): JSX.Element {
    const providersGroupedByBaseProvider = _.groupBy(
      this.props.providers,
      (provider) => EnzymeUtil.getBaseProvider(provider.name).name
    );
    const isReadOnly = this.props.onChange == null;
    const selectedBaseProvider = EnzymeUtil.getBaseProvider(this.props.value.name);

    return (
      <div className={classNames({'u-small-text': this.props.small})}>
        <select
          className={classNames({'u-width-auto': this.props.inline})}
          style={this.props.small ? {height: 20} : undefined}
          value={selectedBaseProvider.name}
          onChange={this.providerSelectHandler}
          disabled={isReadOnly}
        >
          {EnzymeConstants.baseProviders
            // eslint-disable-next-line benchlint/no-in-operator
            .filter((provider) => provider.name in providersGroupedByBaseProvider)
            .map(({name}) => (
              <option value={name} key={name}>
                {name}
              </option>
            ))}
        </select>
        {this.renderSubProviderChooser()}
      </div>
    );
  }
}

export default EnzymeProviderSelector;
